import React from "react";
import { Stage, Layer } from "react-konva";
import "../../utils/patchKonva";
import { timeToAngle } from "./utils";
import { ClockFace } from "./ClockFace";
import { HeatRange } from "./HeatRange";
var SIZE = 400;
var RADIUS = 170;
var OFFSET = -SIZE / 2;
export function SchedulePreview(_ref) {
  var ranges = _ref.ranges,
      size = _ref.size;
  var angleRanges = ranges.map(function (range) {
    return range.map(timeToAngle);
  });
  return /*#__PURE__*/React.createElement(Stage, {
    width: size,
    height: size,
    offsetX: OFFSET,
    offsetY: OFFSET,
    listening: false,
    scaleX: size / SIZE,
    scaleY: size / SIZE
  }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(ClockFace, {
    clockRadius: RADIUS
  })), /*#__PURE__*/React.createElement(Layer, {
    rotation: -90
  }, angleRanges.map(function (range) {
    return /*#__PURE__*/React.createElement(HeatRange, {
      key: range[0],
      range: range,
      clockRadius: RADIUS
    });
  })));
}